// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

import React from 'react';

import Svg, { SvgProps } from '../Svg';

const Clip: React.FC<SvgProps> = (props) => (
  <Svg width="24.05" height="27.252" {...props} viewBox="0 0 24.05 27.252">
    <path
      id="パス_92"
      data-name="パス 92"
      d="M21.667-19.917a3.42,3.42,0,0,0-4.834,0L6.77-9.855a5.892,5.892,0,0,0,0,8.334,5.892,5.892,0,0,0,8.334,0l8.313-8.312a1.535,1.535,0,0,1,2.166,0,1.535,1.535,0,0,1,0,2.166L17.27.645A8.951,8.951,0,0,1,4.6.645a8.951,8.951,0,0,1,0-12.666L14.667-22.083a6.479,6.479,0,0,1,9.166,0,6.479,6.479,0,0,1,0,9.166L14.208-3.292a4.007,4.007,0,0,1-5.666,0,4.007,4.007,0,0,1,0-5.666l7.875-7.875a1.535,1.535,0,0,1,2.166,0,1.535,1.535,0,0,1,0,2.166L10.708-6.792a.947.947,0,0,0,0,1.334.947.947,0,0,0,1.334,0l9.625-9.625A3.42,3.42,0,0,0,21.667-19.917Z"
      transform="translate(-1.98 23.982)"
      fill="currentColor"
    />
  </Svg>
);

Clip.displayName = 'Clip';

export default Clip;
